var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("类目管理")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "Box" }, [
        _c("div", { staticClass: "table_tab" }, [
          _c(
            "div",
            { staticClass: "inquiry" },
            [
              _vm._m(0),
              _c("div", { staticClass: "headerTitle" }, [_vm._v("数据筛选")]),
              _c(
                "el-form",
                {
                  ref: "queryForm",
                  attrs: {
                    inline: true,
                    model: _vm.queryForm,
                    "label-width": "",
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "类目名称" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入类目名称",
                          clearable: "",
                          maxlength: 20,
                        },
                        model: {
                          value: _vm.queryForm.categoryName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm,
                              "categoryName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "queryForm.categoryName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "编号" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入编号",
                          clearable: "",
                          oninput: "value=value.replace(/[^0-9.]/g,'')",
                          maxLength: 2,
                        },
                        model: {
                          value: _vm.queryForm.categoryNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "categoryNo", $$v)
                          },
                          expression: "queryForm.categoryNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          on: { change: _vm.selectState },
                          model: {
                            value: _vm.queryForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "status", $$v)
                            },
                            expression: "queryForm.status",
                          },
                        },
                        _vm._l(_vm.positionList, function (items) {
                          return _c("el-option", {
                            key: items.value,
                            attrs: { label: items.name, value: items.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "平台" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择平台", clearable: "" },
                          model: {
                            value: _vm.queryForm.platformId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "platformId", $$v)
                            },
                            expression: "queryForm.platformId",
                          },
                        },
                        _vm._l(_vm.platformList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.searchEvent()
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.searchEvent.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.reset()
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "inquiryTab" }, [
            _c(
              "div",
              { staticClass: "inquiryTab_header" },
              [
                _c("div", { staticClass: "tabTitle" }, [_vm._v("列表数据")]),
                _vm.parArray.indexOf("addClassify") != -1
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addClassify()
                          },
                        },
                      },
                      [_vm._v("新增分类")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "table" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "theTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      "row-key": "id",
                      lazy: "",
                      "tree-props": {
                        children: "children",
                        hasChildren: "hasChildren",
                      },
                      data: _vm.tableData.list,
                      "header-cell-style": {
                        background: "#f8f8f8",
                        textAlign: "left",
                      },
                      toggleRowExpansion: { expanded: true },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "类目名称",
                        "min-width": "80",
                        prop: "categoryName",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "编号",
                        prop: "categoryNo",
                        "min-width": "80",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "级别", prop: "levelDesc" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "图标", prop: "imageUrl" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              props.row.imageUrl
                                ? _c("img", {
                                    staticStyle: {
                                      width: "100px",
                                      height: "100px",
                                    },
                                    attrs: { src: props.row.imageUrl },
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "text-align": "left",
                                        "margin-left": "10px",
                                      },
                                    },
                                    [_vm._v("--")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "状态", prop: "status" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "p",
                                {
                                  class:
                                    props.row.status == "A" ? "green" : "red",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(props.row.statusDesc) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "启用平台", prop: "platforms" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "200",
                        label: "更新日期",
                        prop: "updatedTime",
                        "label-class-name": "updatedTime",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm._v(
                                    " " + _vm._s(props.row.updatedTime) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        width: "200",
                        fixed: "right",
                        "label-class-name": "updatedTime",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("div", [
                                _vm.parArray.indexOf("subordinate") != -1 &&
                                props.row.level != 3
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "btnp",
                                        on: {
                                          click: function ($event) {
                                            return _vm.compile(props.row, 1)
                                          },
                                        },
                                      },
                                      [_vm._v(" 新增下级 ")]
                                    )
                                  : _vm._e(),
                                props.row.status == "S" &&
                                _vm.parArray.indexOf("forbidden") != -1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "btnp",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setState(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(" 启用 ")]
                                    )
                                  : _vm._e(),
                                props.row.status == "A" &&
                                _vm.parArray.indexOf("categoryEnable") != -1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "btnp",
                                        on: {
                                          click: function ($event) {
                                            return _vm.getGoodsNum(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(" 禁用 ")]
                                    )
                                  : _vm._e(),
                                _vm.parArray.indexOf("classifyEdit") != -1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "btnp",
                                        on: {
                                          click: function ($event) {
                                            return _vm.compile(props.row, 2)
                                          },
                                        },
                                      },
                                      [_vm._v(" 编辑 ")]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm.tableData.totalNum > 0
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pageNo,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.tableData.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增分类",
            "close-on-click-modal": false,
            "append-to-body": "",
            visible: _vm.addClassifyDialogVisible,
            width: "30%",
            "before-close": _vm.handleCloseAddClassify,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addClassifyDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分类名称：", prop: "categoryName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入分类名称" },
                    model: {
                      value: _vm.form.categoryName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "categoryName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.categoryName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上级分类：" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请选择上级分类",
                      clearable: "",
                      options: _vm.options,
                      props: {
                        label: "categoryName",
                        value: "id",
                        expandTrigger: "hover",
                        checkStrictly: true,
                      },
                    },
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.form.parentId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "parentId", $$v)
                      },
                      expression: "form.parentId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上传图标：" } },
                [
                  _c("headerPicture", {
                    attrs: { qrCodeUrl: _vm.form.imageUrl },
                    on: {
                      getUrl: function ($event) {
                        return _vm.getImage($event, "0")
                      },
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "line-height": "20px",
                        "margin-top": "8px",
                      },
                    },
                    [
                      _vm._v(
                        "图片尺寸：建议上传1:1比例，每张上传大小不得超过2M,支持jpg、jpeg、png格式"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "A" } }, [
                        _vm._v("启用"),
                      ]),
                      _c("el-radio", { attrs: { label: "S" } }, [
                        _vm._v("禁用"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { float: "right" } },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.addClassifyDialogVisible = false
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.classifyAdd("form")
                          },
                        },
                      },
                      [_vm._v("提交")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.toInfoDialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.btnText,
                "close-on-click-modal": false,
                "append-to-body": "",
                visible: _vm.toInfoDialogVisible,
                width: "30%",
                "before-close": _vm.handleCloseToInfo,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.toInfoDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    rules: _vm.ruleFormRules,
                    model: _vm.ruleForm,
                    "label-width": "100px",
                  },
                },
                [
                  _vm.btnText == "编辑"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "编号：", prop: "categoryNo" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: true,
                              oninput: "value=value.replace(/[^0-9.]/g,'')",
                              maxLength: 2,
                            },
                            model: {
                              value: _vm.ruleForm.categoryNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "categoryNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "ruleForm.categoryNo",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "分类名称：", prop: "categoryName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入分类名称" },
                        model: {
                          value: _vm.ruleForm.categoryName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "categoryName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.categoryName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上级分类：" } },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请选择上级分类",
                          disabled: _vm.forbidden,
                          options: _vm.rowList,
                          props: {
                            label: "categoryName",
                            value: "id",
                            expandTrigger: "hover",
                            checkStrictly: true,
                          },
                        },
                        on: { change: _vm.handleChangeSubordinate },
                        model: {
                          value: _vm.ruleForm.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "value", $$v)
                          },
                          expression: "ruleForm.value",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上传图标：" } },
                    [
                      _c("headerPicture", {
                        attrs: { qrCodeUrl: _vm.ruleForm.imageUrl },
                        on: {
                          getUrl: function ($event) {
                            return _vm.getImage($event, "1")
                          },
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "line-height": "20px",
                            "margin-top": "8px",
                          },
                        },
                        [
                          _vm._v(
                            "图片尺寸：建议上传1:1比例，每张上传大小不得超过2M,支持jpg、jpeg、png格式"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态：", prop: "status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "status", $$v)
                            },
                            expression: "ruleForm.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "A" } }, [
                            _vm._v("启用"),
                          ]),
                          _c("el-radio", { attrs: { label: "S" } }, [
                            _vm._v("禁用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.toInfoDialogVisible = false
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.addSubordinate("ruleForm")
                              },
                            },
                          },
                          [_vm._v("提交")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisibleGoods,
            "append-to-body": "",
            width: "30%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleGoods = $event
            },
          },
        },
        [
          _c("span", [
            _vm._v("该类目下还有"),
            _c("span", { staticStyle: { color: "red" } }, [
              _vm._v(_vm._s(_vm.goodsNumber) + "个"),
            ]),
            _vm._v("商品，请先下架商品！"),
          ]),
          _c(
            "div",
            { staticClass: "btnClass" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisibleGoods = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisibleGoods = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headerbox" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title_left" }),
        _vm._v(" 类目管理 "),
      ]),
      _c("div", { staticClass: "headerbox_right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }